import React, { useEffect, useState } from 'react';
import PlusMinusInputWithDebounceRFQ from 'src/component/custom/PlusMinusInputWithDebounceRFQ';
import { useQuoteStore } from 'src/hooks/quote';
import produceClone from "../../../helper/produceClone";
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import CustomerPartNumberOptions from "../../../component/custom/CustomerPartNumberOptions";
import { useCartStore } from 'src/hooks/cart';
import Modal from "../../../component/Global/Modal";

const QuotePopup = (props) => {
    const { data, SetStatus } = props;
    const { siteUser, validateQtyMsg, systemModules: { Quote }, currencyType: { USD } } = Constants;
    const { current_quote } = data;
    const [__check] = useAxiosIndicatorCheck();
    const isEdit = !!current_quote;
    const currentProduct = data?.single_product;
    const targetUnitPricePattern = /^(\d+)(\d{1,2}|\.\d{1,5})?$/;
    const defaultQtyVal = false;
    const modal = {
        customerPartNumber: '',
        targetCurrency: USD,
        quantity1: currentProduct.QtyMin,
        quantity2: defaultQtyVal,
        quantity3: defaultQtyVal,
        targetUnitPrice: '',
    }
    const [rfqQty, setRfqQty] = useState(isEdit ? current_quote.quantity1 : currentProduct?.QtyMin);
    const [quoteDetail, setQuoteDetail] = useState(modal);
    const [detailValidation, setDetailValidation] = useState({});
    const [{ }, { get_RFQ_quantity, add_open_quote }, { edit_quote_save, set_is_success_action }] = useQuoteStore();
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [isFirstCall, setIsFirstCall] = useState(true);

    const [isDisabled, setIsDisabled] = useReduxState(false, 'setIsDisabled');
    const addFrom = data?.addFrom
    const [qtyLoader] = useReduxState(false, 'setQtyLoader');
    const loader = __check("ADD_TO_QUOTE_API_CALL").status;


    useEffect(() => {
        SetStatus(true);

        const rfqVal = get_RFQ_quantity(currentProduct, props.data.single_product_pricing_list);
        setRfqQty(rfqVal);

        if (isEdit) {
            const detail = data?.current_quote;
            const detailModal = {
                quoteLineItemId: detail.quoteLineItemId,
                customerPartNumber: detail.customerPartNumber ? detail.customerPartNumber : "",
                quantity1: detail.quantity1,
                quantity2: detail?.quantity2 === 0 ? false : detail?.quantity2,
                quantity3: detail?.quantity3 === 0 ? false : detail?.quantity3,
                targetUnitPrice: detail.targetUnitPrice,
                targetCurrency: detail.targetCurrency,
            }

            setQuoteDetail(detailModal);
        } else {
            let _productCPN = CART_BEFORE_TO_SEND_SERVER[currentProduct.ItemNumber].CPN ? CART_BEFORE_TO_SEND_SERVER[currentProduct.ItemNumber].CPN : ""

            if (currentProduct.CustomerPartNumbers?.length === 1 && !_productCPN) {
                _productCPN = currentProduct.CustomerPartNumbers ? currentProduct.CustomerPartNumbers[0].CPN : ""
            }

            setQuoteDetail({ ...quoteDetail, quantity1: rfqVal, customerPartNumber: _productCPN })
        }

    }, []);

    const onValueChange = (field, value) => {
        setQuoteDetail({ ...quoteDetail, [field]: value });
    }

    const onHide = () => {
        SetStatus(false)
    };

    const handleChange = (i, e) => {
        const qty = `quantity${i}`;
        onValueChange(qty, e.target.value);

        if (e.target.err) {
            setDetailValidation({ ...detailValidation, [qty]: e.target.err });
        } else {
            const validation = produceClone(detailValidation);
            delete validation[qty];
            setDetailValidation(validation);
        }
    }
    const removeFormFields = (i) => {
        const detailModel = produceClone(quoteDetail);
        const validation = produceClone(detailValidation);

        if (i === 2) {
            delete validation?.quantity2
            if (detailModel.quantity3 !== defaultQtyVal) {
                detailModel.quantity2 = detailModel.quantity3;
                detailModel.quantity3 = defaultQtyVal;
                if (validation?.quantity3) {
                    validation.quantity2 = validation.quantity3;
                    delete validation.quantity3
                }
            } else {
                detailModel.quantity2 = defaultQtyVal;
            }
        } else {
            detailModel.quantity3 = defaultQtyVal;
            delete validation?.quantity3
        }
        setQuoteDetail(detailModel)
        setDetailValidation(validation)
    }

    const onSubmit = async () => {

        const params = { ...quoteDetail };
        const isValid = await validateData(params);
        if (!isValid) {
            return false;
        } else {
            params.quantity2 = params.quantity2 ? params.quantity2 : null;
            params.quantity3 = params.quantity3 ? params.quantity3 : null;

            if (isEdit) {
                const quotes = [{ params }]
                await edit_quote_save(quotes);
                set_is_success_action(true)
                onHide();
            } else {
                if (currentProduct) {
                    if (currentProduct.ERPPartNumber) {
                        params.partNumber = currentProduct.ERPPartNumber;
                    }
                    params.itemNumber = currentProduct.ItemNumber;
                    params.erpManufacturerPartNumber = currentProduct.ERPMFRPartNumber;
                    params.erpManufacturerCode = currentProduct.ERPManufacturerCode;
                    params.manufacturerName = currentProduct.ManufacturerName;
                }

                await add_open_quote(params).then(res => {
                    onHide();
                    // let propsData = {...props.data};
                    // propsData.quantity = res?.data?.quantity1;
                    // propsData.quoteLineItemId = res?.data?.quoteLineItemId;
                    // System.popup('AddedPartQuotePopup', { data: { quoteDetail: propsData, ...data } })
                    res.data.addFrom = addFrom;

                    System.popup('AddedPartQuotePopup', { data: { quoteDetail: res.data, ...data } })
                    resetForm();
                })

                System.setEvars(currentProduct.ERPMFRPartNumber, "Add to Quote clicked from " + addFrom)
            }
        }
    };


    const validateDuplicateQty = (field, qty1, qty2, qty3) => {
        if (field === 'quantity1' && ((qty2 && qty2 > 0 && qty1 === qty2) || (qty3 && qty3 > 0 && qty1 === qty3))) {
            return false;
        } else if (field === 'quantity2' && ((qty1 && qty1 > 0 && qty2 === qty1) || (qty3 && qty3 > 0 && qty2 === qty3))) {
            return false;
        } else if (field === 'quantity3' && ((qty1 && qty1 > 0 && qty3 === qty1) || (qty2 && qty2 > 0 && qty3 === qty2))) {
            return false;
        } else
            return true;
    }

    const validateRegex = (term, expr) => {
        const re = new RegExp(expr);
        if (re.test(term)) {
            return true;
        }
        return false;
    }

    const validateTargetUnitPrice = (value, expr) => {
        if (!Helper.valueIsNotNull(value)) {
            return true;
        }
        return validateRegex(value, expr);
    }

    const validateData = async (params) => {
        if (Object.entries(detailValidation).length > 0) {
            return false;
        } else {
            params.quantity2 = !params.quantity2 ? 0 : params.quantity2;
            params.quantity3 = !params.quantity3 ? 0 : params.quantity3;
            const isValid3 = await validateDuplicateQty('quantity3', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid3) {
                setDetailValidation({ quantity3: validateQtyMsg })
                return false;
            }

            const isValid2 = await validateDuplicateQty('quantity2', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid2) {
                setDetailValidation({ quantity2: validateQtyMsg })
                return false;
            }

            const isValid1 = await validateDuplicateQty('quantity1', params.quantity1, params.quantity2, params.quantity3);
            if (!isValid1) {
                setDetailValidation({ quantity1: validateQtyMsg })
                return false;
            }

            const isValidTargetField = validateTargetUnitPrice(params.targetUnitPrice, targetUnitPricePattern);
            if (!isValidTargetField) {
                setDetailValidation({ targetUnitPrice: 'Invalid entry. Only use dot as a decimal separator.' })
                return false;
            }
            return true;
        }
    }

    const resetForm = () => {
        setQuoteDetail(modal);
        setDetailValidation({})
    };


    const onSelectCPN = async (cpnDetail) => {
        if (isEdit && isFirstCall) {
            setIsFirstCall(false)
            return;
        }
        const priceList = cpnDetail.price[currentProduct.ItemNumber].pricing;
        const rfqVal = get_RFQ_quantity(currentProduct, priceList);
        setRfqQty(rfqVal)
        setQuoteDetail({
            ...quoteDetail,
            quantity1: rfqVal,
            quantity2: (quoteDetail.quantity2 !== defaultQtyVal ? rfqVal : defaultQtyVal),
            quantity3: (quoteDetail.quantity3 !== defaultQtyVal ? rfqVal : defaultQtyVal),
            customerPartNumber: cpnDetail.cpn
        });
        setDetailValidation({});
    };

    const removeQuoteDetailValidation = (validationKey) => {
        if (Object.keys(detailValidation).length > 0 && detailValidation[validationKey]) {
            delete detailValidation[validationKey]
            return true;
        }
        return false;
    }

    const validateTargetPrice = (name, value) => {
        let t = value;
        t = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 6)) : t;
        onValueChange(name, t);
        if (detailValidation[name]) {
            const isValidTargetField = validateTargetUnitPrice(t, targetUnitPricePattern);
            if (isValidTargetField)
                removeQuoteDetailValidation(name);
        }

    }

    const validateNumber = (evt, inputVal) => {
        removeQuoteDetailValidation('targetUnitPrice');
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode === 46) {
            if (!(inputVal && inputVal.indexOf(".") > -1)) {
                return true;
            }
        }
        return !(charCode > 31 && (charCode < 48 || charCode > 57));

    }

    return (

        <Modal isDrag={true} show={data} onHide={() => onHide()}>
            <div className="avnet-modal modal-730">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close pt-3" data-dismiss="modal" disabled={loader}
                        onClick={onHide}>×
                    </button>
                    {/* {ReusableDiv.PopupTitle("Request a Quote")} */}
                    <div className="modal-header border-0" onMouseEnter={() => setIsDisabled(false)}
                        onMouseLeave={() => setIsDisabled(true)}>
                        <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                    </div>
                    {/* Modal body */}
                    {currentProduct &&
                        <div className="modal-body px-md-5 pb-4">
                            <div className="clearfix" />
                            <div className="label-value mb-3">
                                <div className="label-value-item">
                                    <label><b>Quote No:</b></label>
                                    <span>Open</span>
                                </div>
                                <div className="label-value-item">
                                    <label><b>Part Number:</b></label>
                                    <span>{currentProduct.ERPMFRPartNumber}</span>
                                </div>
                                <div className="label-value-item">
                                    <label><b>Manufacturer:</b></label>
                                    <span>{currentProduct.ManufacturerName}</span>
                                </div>
                            </div>
                            <div className="bs5 row" onClick={() => !isDisabled && setIsDisabled(true)}>
                                {System.avUserInfoData.currentUser === siteUser.CORE && currentProduct?.CustomerPartNumbers?.length > 0 &&
                                    <div className="col-md-6">
                                        {currentProduct?.CustomerPartNumbers?.length === 1 ? <>
                                            <div className="form-group">
                                                <label htmlFor="sel1" className="text-nowrap"><b>Customer Part Number</b></label>
                                                <br />
                                                {currentProduct.CustomerPartNumbers[0].CPN}
                                            </div>
                                        </> :
                                            <CustomerPartNumberOptions
                                                single_product={currentProduct}
                                                updationCompletedCallback={async (cpnDetail) => {
                                                    onSelectCPN(cpnDetail)
                                                }}
                                                from={Quote}
                                                defaultValue={quoteDetail.customerPartNumber}
                                            />
                                        }
                                    </div>}

                                <div className="col-12"><b>Minimum Required Quantity for Quoting</b>

                                </div>
                                <div className="col-md-6">

                                    <label htmlFor="Quantity" className="form-label d-block">Quantity 1</label>

                                    <div className='bs5 col px-0'>
                                        <div className='position-relative'>

                                            {qtyLoader &&
                                                <div className='btn-sm w-100 inputloader'>
                                                    <i className="fa fa-spinner fa-spin" />
                                                </div>
                                            }

                                            <PlusMinusInputWithDebounceRFQ
                                                disable_validation_check={true}
                                                name="quantity1" type="text"
                                                className="form-control form-control-sm input-number bg-white"
                                                QtyMin={rfqQty}
                                                QtyMult={currentProduct.QtyMult}
                                                force_default_quantity={quoteDetail.quantity1}
                                                onChange={(err, value) => {
                                                    handleChange(1, {
                                                        target: {
                                                            'name': "quantity1",
                                                            err,
                                                            value
                                                        }
                                                    });
                                                }}
                                            />
                                        </div>
                                        {detailValidation.quantity1 &&
                                            <p className="error"> {detailValidation.quantity1}</p>}
                                    </div>
                                    {quoteDetail.quantity2 === defaultQtyVal ?
                                        <a className={`add-more d-block mb-2 text-blue2 ${(qtyLoader === true) ? 'pe-none text-muted' : ''} `}
                                            disabled={qtyLoader === true}
                                            onClick={(value) => {
                                                onValueChange('quantity2', rfqQty)
                                            }}>+ Add another quantity</a> : null
                                    }

                                    {/* Qty 2 */}
                                    {(quoteDetail.quantity2 !== defaultQtyVal) ?
                                        <>

                                            <label htmlFor="Quantity" className="form-label d-block">Quantity 2</label>
                                            <div className='bs5 col px-0'>
                                                <div className='rfq-quantity-close position-relative'>
                                                    {qtyLoader &&
                                                        <div className='btn-sm w-100 inputloader'>
                                                            <i className="fa fa-spinner fa-spin" />
                                                        </div>
                                                    }
                                                    <PlusMinusInputWithDebounceRFQ
                                                        disable_validation_check={true}
                                                        name="quantity2" type="text"
                                                        className="form-control form-control-sm input-number bg-white"
                                                        QtyMin={rfqQty}
                                                        QtyMult={currentProduct.QtyMult}
                                                        force_default_quantity={quoteDetail.quantity2}
                                                        onChange={(err, value) => {
                                                            handleChange(2, {
                                                                target: {
                                                                    'name': "quantity2",
                                                                    err,
                                                                    value
                                                                }
                                                            });
                                                        }}
                                                    />

                                                    <div className='bs5 col-auto px-0'>
                                                        <button type="button"
                                                            className="remove-email btn-link text-black-stone mb-0 py-1">
                                                            <span className="fa fa-times"
                                                                onClick={() => removeFormFields(2)} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {detailValidation.quantity2 &&
                                                <p className="error"> {detailValidation.quantity2}</p>}
                                            {quoteDetail.quantity3 === defaultQtyVal &&
                                                <a className={`add-more d-block mb-2 text-blue2 ${(qtyLoader === true) ? 'pe-none text-muted' : ''} `}
                                                    disabled={qtyLoader === true}
                                                    onClick={(value) => {
                                                        onValueChange('quantity3', rfqQty)
                                                    }}>+ Add another quantity</a>
                                            }
                                        </> : null}

                                    {/* Qty 3 */}
                                    {(quoteDetail.quantity3 !== defaultQtyVal) ?
                                        <>
                                            <label htmlFor="Quantity" className="form-label d-block">Quantity 3</label>


                                            <div className='bs5 col px-0'>
                                                <div className='rfq-quantity-close position-relative'>
                                                    {qtyLoader &&
                                                        <div className='btn-sm w-100 inputloader'>
                                                            <i className="fa fa-spinner fa-spin" />
                                                        </div>
                                                    }

                                                    <PlusMinusInputWithDebounceRFQ
                                                        disable_validation_check={true}
                                                        name="quantity3" type="text"
                                                        className="form-control form-control-sm input-number bg-white"
                                                        QtyMin={rfqQty}
                                                        QtyMult={currentProduct.QtyMult}
                                                        force_default_quantity={quoteDetail.quantity3}
                                                        onChange={(err, value) => {
                                                            handleChange(3, {
                                                                target: {
                                                                    'name': "quantity3",
                                                                    err,
                                                                    value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    <div className='bs5 col-auto px-0'>
                                                        <button type="button"
                                                            className="remove-email btn-link text-black-stone mb-0 py-1">
                                                            <span className="fa fa-times"
                                                                onClick={() => removeFormFields(3)} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {detailValidation.quantity3 &&
                                                <p className="error"> {detailValidation.quantity3}</p>}
                                        </> : null}
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-3 price-inputbox">
                                        <label htmlFor="Unit" className="form-label d-block">Target Unit Price
                                            (Optional)</label>
                                        <div className='bs5 input-group'>
                                            <span className="input-group-text">$</span>
                                            <input type="text" className="form-control form-control-sm"
                                                id="targetUnitPrice"
                                                name="targetUnitPrice"
                                                value={quoteDetail.targetUnitPrice || ''}
                                                maxLength={14}
                                                onChange={({ target: { value } }) => validateTargetPrice('targetUnitPrice', value)}
                                                onKeyPress={(evt) => validateNumber(evt, evt.target.value) === false && evt.preventDefault()}
                                            />
                                        </div>

                                        {detailValidation.targetUnitPrice &&
                                            <p className="error"> {detailValidation.targetUnitPrice}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* Modal footer */}
                    <div className="modal-footer d-block text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal"
                                data-bs-target="#RequestModal"
                                disabled={loader}
                                onClick={onHide}>
                                CANCEL
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145" data-bs-toggle="modal"
                                disabled={loader || Object.keys(detailValidation).length > 0}
                                data-bs-target="#RequestModal"
                                onClick={onSubmit}>
                                {loader ? <i className="fa fa-spinner fa-spin" /> : (isEdit ? 'Save Changes' : 'Add to quote')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

    );
}

export default QuotePopup;